import { useState, useRef } from 'react'
import Box from '@mui/joy/Box'
import { Loading } from './ui/Loading'
import { OrgAPI } from '../api/OrgAPI'
import { TemplateInterpolator } from '../common/TemplateInterpolator'
import { useQuery } from '@tanstack/react-query'
import { AIAPI } from '../api/AIAPI'
import _ from 'lodash'

export const Interpolator = ({ varsMap, templates, onStatusChanged }) => {
    const [done, setDone] = useState(0)
    const dataArr = useRef([])

    const _buildPrompt = (promptTemplate, varsMap) => {
        // Matching for template tokens (i.e. "{{ variable }}")
        const re = /{{([^}]+)}}/g
        var matches = []

        matches = [...promptTemplate.matchAll(re)]
        let transformedText = promptTemplate
        matches.forEach((match) => {
            transformedText = transformedText.replace(
                match[0],
                varsMap[match[1].trim()]
            )
        })
        return transformedText
    }

    const replacePromptObject = async (obj, varsMap) => {
        // Interpolate necessary data into prompt from varsMap
        const fullPrompt = _buildPrompt(obj.prompt, varsMap)

        // Fetch AI Response
        const response = await AIAPI.getTemplatePrompt(fullPrompt)
        const text = response.data.results
        return { [obj.name]: text }
    }

    const _init = () => {
        let promises = []
        templates.forEach((template) => {
            template.canvas.objects.forEach((obj) => {
                if (!(obj.type === 'prompt-textbox')) {
                    // Not valid for interpolation...skipping.
                    return
                }

                promises.push(replacePromptObject(obj, varsMap))
            })
            Promise.all(promises).then((data) => {
                const updatedVars = _.reduce(
                    data,
                    (result, item) => {
                        for (var key in item) {
                            result[key] = item[key]
                        }
                        return result
                    },
                    varsMap
                )

                const mergedMap = { ...updatedVars, ...brandKit }
                TemplateInterpolator.interpolate(template.canvas, mergedMap)
                    .then((data) => {
                        dataArr.current.push(data)
                    })
                    .catch((e) => {
                        console.log(
                            'an error occurred while interpolating a template',
                            e
                        )
                    })
                    .finally(() => {
                        setDone((prev) => {
                            let val = prev + 1
                            if (val == templates.length) {
                                onStatusChanged(dataArr.current)
                            }
                            return val
                        })
                    })
            })
        })
        return null
    }

    const { data: brandKit } = useQuery({
        queryKey: ['kit'],
        queryFn: OrgAPI.getBrandKit,
    })
    const {
        status,
        fetchStatus,
        data: result,
    } = useQuery({ queryKey: ['_init'], queryFn: _init, enabled: !!brandKit })

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Loading
                message={`Building templates...${done}/${templates.length} completed`}
            />
        </Box>
    )
}
